var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThailand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2536 7.82605H0.746391C0.264 9.12603 0 10.5321 0 11.9999C0 13.4678 0.264 14.8738 0.746391 16.1738H23.2537C23.736 14.8738 24 13.4678 24 11.9999C24 10.5321 23.736 9.12603 23.2536 7.82605Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 0C8.36285 0 5.10396 1.61831 2.90332 4.17389H21.0965C18.8959 1.61831 15.637 0 11.9999 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0965 19.826H2.90332C5.10396 22.3816 8.36285 23.9999 11.9999 23.9999C15.637 23.9999 18.8959 22.3816 21.0965 19.826Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/33713714.svg";
export { SvgThailand as ReactComponent };